





































































import { Component, Prop, Vue } from 'vue-property-decorator';

import snackModule from '@/store/Snack';
import {
  collectDroppedFiles,
  collectPickedFolderFiles,
} from '@/components/upload/collect-files';

@Component({
  components: {},
})
export default class FaunaMediaUploader extends Vue {
  @Prop({ default: false }) readonly disabled: boolean;

  @Prop({ default: true }) readonly complete: boolean;

  inDrag = false;

  /**
   * trigger the hidden file input field to show system dialog
   */
  async initFileUpload() {
    if (this.$refs.fileInput) {
      (this.$refs.fileInput as HTMLInputElement).click();
    }
  }

  /**
   * trigger the hidden folder input field to show system dialog
   */
  initFolderUpload() {
    if (this.$refs.folderInput) {
      (this.$refs.folderInput as HTMLInputElement).click();
    }
  }

  /**
   * emit the files to upload, warning instead if there are no jpegs
   */
  emitUpload(files: File[]) {
    if (!files.length) {
      snackModule.setError({
        text: 'No JPEG photos found. Photos in sub-folders are not added.',
        errors: undefined,
      });
      return;
    }
    this.$emit('upload', files);
  }

  /**
   * The event that gets triggered when files are selected using system dialog
   */
  onFileChange(e: Event) {
    console.log('file change', e);
    const { files } = e.target as HTMLInputElement;
    if (!files) {
      console.warn('no files');
      return;
    }
    this.emitUpload(Array.from(files));
    (e.target as HTMLInputElement).value = '';
  }

  /**
   * The event that gets triggered when a folder is selected using system dialog
   */
  onFolderChange(e: Event) {
    const { files } = e.target as HTMLInputElement;
    if (!files) {
      return;
    }
    this.emitUpload(collectPickedFolderFiles(files));
    (e.target as HTMLInputElement).value = '';
  }

  /**
   * Handle the drop event
   * gets the presigned urls for the files and starts the upload
   */
  async onDrop(e: DragEvent) {
    e.preventDefault();
    this.inDrag = false;

    if (this.disabled) {
      return;
    }

    if (!e.dataTransfer) {
      console.warn('no data transfer - no files??');
      return;
    }
    this.emitUpload(await collectDroppedFiles(e.dataTransfer));
  }

  /**
   * Sets the UI for dropping files
   */
  onDragOver(e: DragEvent) {
    e.stopPropagation();
    e.preventDefault();
    if (this.disabled) {
      return;
    }

    this.inDrag = true;
    if (e.dataTransfer) {
      e.dataTransfer.dropEffect = 'copy';
    }
  }

  /**
   * Resets the UI for dropping files
   */
  onDragLeave(e: DragEvent) {
    e.preventDefault();
    this.inDrag = false;
  }
}
